export default "__VITE_ASSET__999a7eeb__"